import React, { useEffect, useState } from 'react';
import { useUserAuth } from '../../context/UserAuthContext';
import { API } from '../../api';
import { fmtMoney } from '../../utils/media';
import { Package, Mail, Calendar, ShoppingBag, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function AccountDashboard() {
  const { user, authHeader } = useUserAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => { API.get('/user/orders', { headers: authHeader() }).then((r) => setOrders(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-3 gap-4">
        <div className="rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] p-6">
          <ShoppingBag className="w-6 h-6 text-[#f4d896] mb-3" />
          <div className="font-display text-3xl font-black text-white">{orders.length}</div>
          <div className="text-xs text-white/50 tracking-widest mt-1">TOPLAM SİPARİŞ</div>
        </div>
        <div className="rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] p-6">
          <Package className="w-6 h-6 text-emerald-400 mb-3" />
          <div className="font-display text-3xl font-black text-white">{orders.filter(o => o.status === 'completed').length}</div>
          <div className="text-xs text-white/50 tracking-widest mt-1">TAMAMLANAN</div>
        </div>
        <div className="rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] p-6">
          <Mail className="w-6 h-6 text-blue-300 mb-3" />
          <div className="text-sm text-white truncate">{user?.email}</div>
          <div className="text-xs text-white/50 tracking-widest mt-1">HESAP</div>
        </div>
      </div>

      <div className="rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-xl font-bold text-white">Son Siparişlerim</h3>
          <Link to="/account/orders" className="text-xs text-[#f4d896] hover:underline inline-flex items-center gap-1">Tümünü gör <ArrowRight className="w-3 h-3" /></Link>
        </div>
        {orders.length === 0 ? (
          <div className="py-8 text-center">
            <p className="text-white/50 mb-4">Henüz siparişiniz yok.</p>
            <Link to="/products" className="btn-gold h-10 px-5 rounded-full text-xs font-extrabold tracking-widest inline-flex items-center gap-2">ALIŞVERİŞE BAŞLA</Link>
          </div>
        ) : (
          <div className="space-y-2">
            {orders.slice(0, 5).map((o) => (
              <div key={o.id} className="flex items-center justify-between p-3 rounded-lg border border-white/8 bg-white/[0.02]">
                <div><div className="text-sm text-white">#{o.id.slice(0, 8)}</div><div className="text-xs text-white/50"><Calendar className="inline w-3 h-3 mr-1" /> {String(o.created_at).slice(0, 10)}</div></div>
                <div className="text-right"><div className="font-display text-lg font-black gold-text">{fmtMoney(o.total)} ₺</div><div className="text-xs text-white/50">{o.status}</div></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export function AccountOrders() {
  const { authHeader } = useUserAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => { API.get('/user/orders', { headers: authHeader() }).then((r) => setOrders(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h2 className="font-display text-2xl font-black text-white mb-6">Siparişlerim</h2>
      {orders.length === 0 ? <p className="text-white/60">Henüz siparişiniz yok.</p> : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] p-5">
              <div className="flex justify-between mb-4">
                <div><div className="text-sm text-white">#{o.id.slice(0, 8)}</div><div className="text-xs text-white/50"><Calendar className="inline w-3 h-3 mr-1" />{String(o.created_at).slice(0, 10)}</div></div>
                <div className="text-right"><div className="font-display text-xl font-black gold-text">{fmtMoney(o.total)} ₺</div><span className="inline-block mt-1 px-2 py-0.5 text-[10px] rounded bg-[#e4b44e]/15 border border-[#e4b44e]/30 text-[#f4d896] tracking-widest">{o.status.toUpperCase()}</span></div>
              </div>
              <div className="border-t border-white/8 pt-3 space-y-1">
                {o.items.map((it, i) => (<div key={i} className="flex justify-between text-sm"><span className="text-white/70">{it.name} ×{it.quantity}</span><span className="text-white/60">{fmtMoney(it.price * it.quantity)} ₺</span></div>))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function AccountWishlist() {
  return (
    <div>
      <h2 className="font-display text-2xl font-black text-white mb-6">Favorilerim</h2>
      <p className="text-white/60">Favorilerinize eklediğiniz ürünler burada görünecek.</p>
    </div>
  );
}

export function AccountProfile() {
  const { user } = useUserAuth();
  return (
    <div>
      <h2 className="font-display text-2xl font-black text-white mb-6">Profil Bilgileri</h2>
      <div className="rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] p-6 space-y-4 max-w-lg">
        <div><div className="text-xs text-white/40 tracking-widest">AD SOYAD</div><div className="text-white mt-1">{user?.name || '-'}</div></div>
        <div><div className="text-xs text-white/40 tracking-widest">E-POSTA</div><div className="text-white mt-1">{user?.email}</div></div>
        <div><div className="text-xs text-white/40 tracking-widest">HESAP OLUŞTURULMA</div><div className="text-white mt-1">{user?.created_at ? String(user.created_at).slice(0, 10) : '-'}</div></div>
      </div>
    </div>
  );
}
